'use client'

// MUI Imports
import Grid from '@mui/material/Grid'

// Component Imports
import PremiumModuleCards from './PremiumModuleCards'
import PremiumModuleTable from './PremiumModuleTable'

const PremiumModuleWrapper = ({
    moduleName = 'Task',
    stats,
    onStatusClick,
    data,
    columns,
    totalRecords,
    currentPage,
    itemsPerPage,
    onPageChange,
    onRowSelectionChange,
    rowSelection,
    onManualRowSelectionChange,
    globalFilter,
    onGlobalFilterChange,
    children, // Added children support
    customCards, // New prop for module-specific scorecards
    showCards = true, // Add showCards prop with default value true
    showTable = true,  // New prop to toggle table visibility
    activeFilters = ['All'],
    loading = false,
    hasFetched = true,
    isInitialLoad = false,
    onItemsPerPageChange,
    px = '24px', // Added px prop for horizontal alignment control
    sorting,
    onSortingChange,
    renderSubComponent,
    getRowCanExpand
}) => {
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%', padding: 0, margin: 0, boxSizing: 'border-box', display: 'flex', flexDirection: 'column', overflow: 'visible', flex: 1, minHeight: 0 }}>
            {showCards && (
                <div style={{ width: '100%', marginBottom: '0px', flexShrink: 0, position: 'relative', zIndex: 99, overflow: 'visible' }}>
                    <PremiumModuleCards
                        stats={stats}
                        onStatusClick={onStatusClick}
                        moduleName={moduleName}
                        customCards={customCards}
                        activeFilters={activeFilters}
                        px={px}
                    />
                </div>
            )}
            {/* Inject additional headers/filters here */}
            {children}
            {showTable && (
                <div style={{
                    width: '100%',
                    flex: 1,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    backgroundColor: '#ffffff',
                    position: 'relative',
                    zIndex: 1
                }}>
                    <PremiumModuleTable
                        loading={loading || isInitialLoad}
                        data={data}
                        columns={columns}
                        totalRecords={totalRecords}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                        onRowSelectionChange={onRowSelectionChange}
                        rowSelection={rowSelection}
                        onManualRowSelectionChange={onManualRowSelectionChange}
                        globalFilter={globalFilter}
                        onGlobalFilterChange={onGlobalFilterChange}
                        onItemsPerPageChange={onItemsPerPageChange}
                        hasFetched={hasFetched}
                        sorting={sorting}
                        onSortingChange={onSortingChange}
                        renderSubComponent={renderSubComponent}
                        getRowCanExpand={getRowCanExpand}
                    />
                </div>
            )}
        </div>
    )
}

export default PremiumModuleWrapper
